/// <amd-module name="Search/Shared/Components/ShowMoreRow/ShowMoreRow" />
import * as React from "react";
import * as Resources from "Search/Shared/Resources";
import { Link } from "VSSUI/Link";
import { Spinner } from "VSSUI/Spinner";
import { KeyCode } from "VSSUI/Util";
import { ShowMoreRowProps } from "./ShowMoreRow.Props";

export const ShowMoreRow = (props: ShowMoreRowProps) => {
    return (
        props.needShowMore
            ? <div className={`fontSizeMS show-more ${props.className} flex-row`}>
                {
                    props.needShowMore &&
                    <div className="center-align flex-grow" onKeyDown={evt => evt.keyCode === KeyCode.enter && props.onClick()}>
                        <Link className="show-more-results" onClick={props.onClick} >
                            {Resources.ShowMoreResultsLabel}
                        </Link>
                    </div>
                }

            </div>
            : props.itemsLoading
                ? <Spinner className={`loading-spinner ${props.className}`} label={Resources.FetchingResultsLabel} />
                : null
    );
}
